import * as React from "react";
import "../Styles/style.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import ChatIcon from "@mui/icons-material/Chat";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
import { awsImageURL, baseUrl } from "../../api/ipconfig";
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { AuthContext } from "../../context/AuthContext";
import { Star } from "@mui/icons-material";
import PublishIcon from "@mui/icons-material/Publish";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import FeatureAd from "../modals/feature-ad";
import { Modal, Alert, Snackbar, Box } from "@mui/material";

const checkingModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  minHeight: "15%",
  maxHeight: "95%",
  height: "auto",
  overflowY: "scroll",
};

export default function MyPostedAds() {
  const { user } = React.useContext(AuthContext);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [categoryName, setCategoryName] = useState(null);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popoverState, setPopoverState] = useState({});
  const [openCheckingModal, setOpenCheckingModal] = useState(false);
  const [openFCheckingModal, setOpenFCheckingModal] = useState(false);
  const [successToast, setSuccessToast] = React.useState(false);

  const handleClick = (event, postId) => {
    setPopoverState((prevState) => ({
      ...prevState,
      [postId]: true, // Set the Popover state for the specific Post ID to true
    }));
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (postId) => {
    setPopoverState((prevState) => ({
      ...prevState,
      [postId]: false, // Set the Popover state for the specific Post ID to false
    }));
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "12" : undefined;

  const fetchUserPosts = async () => {
    try {
      const response = await axios.get(`${baseUrl}/userpost`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          user_id: user?.id,
          statusId: 1,
          postTypeId: 1,
        },
      });
      setPosts(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching user posts:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchUserPosts();
    }
  }, [user]);

  const history = useHistory();

  const openPost = (postId) => {
    history.push(`/vehicle-details/${postId}`);
  };

  const editPost = (postId) => {
    history.push(`/post-ad/${postId}`);
  };

  const token = localStorage.getItem("token");

  const soldPost = async (postId) => {
    try {
      await axios.get(`${baseUrl}/fame/markSold`, {
        params: {
          postId: postId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("Post Sold:", postId);
      setPosts((prevPosts) =>
        prevPosts.filter((post) => post.postId !== postId)
      );
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };
  const deletePost = async (postId) => {
    try {
      await axios.delete(`${baseUrl}/fame/posts/${postId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("Post deleted:", postId);
      setPosts((prevPosts) =>
        prevPosts.filter((post) => post.postId !== postId)
      );
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  const formatPrice = (price) => {
    if (price >= 100000000000) {
      return (
        (price / 100000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Kharab"
      );
    } else if (price >= 1000000000) {
      return (
        (price / 1000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Arab"
      );
    } else if (price >= 10000000) {
      return (
        (price / 10000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Crore"
      );
    } else if (price >= 100000) {
      return (
        (price / 100000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " lacs"
      );
    } else if (price >= 1000) {
      return (
        (price / 1000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " Thousand"
      );
    } else {
      return price.toLocaleString("en-US", { maximumFractionDigits: 2 });
    }
  };

  const handleFeatureAd = (postId) => {
    // setCategoryName(capacity);
    // setOpenSuccessModal(true);
    history.push(`/feature-ad/${postId}`);
  };

  const handleBoostAd = async (postId) => {
    try {
      setOpenCheckingModal(true);
      const response = await axios.get(`${baseUrl}/checkboostpackage`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.data.length > 0) {
        const res = await axios.get(`${baseUrl}/consumeboostpackage`, {
          params: {
            purchaseboost_id: response?.data?.data[0]?.purchaseboost_id,
            purchaseboost_remaining:
              response?.data?.data[0]?.purchaseboost_remaining,
            post_id: postId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setSuccessToast(true);
        setOpenCheckingModal(false);
        setTimeout(() => {
          setSuccessToast(false);
        }, 2000);
      } else {
        setOpenFCheckingModal(true);
        setTimeout(() => {
          setOpenFCheckingModal(false);
          history.push(`/feature-ad/${postId}`);
        }, 2000);
      }
    } catch (error) {
      console.error("Error fetching checkboostpackage:", error);
      setOpenCheckingModal(false);
    }
  };

  const handleInspectionAd = (postId) => {
    history.push(`/car-inspection?post${postId}`);
  };
  const successClose = () => {
    setOpenSuccessModal(false);
  };
  const closeCheckingModal = () => {
    setOpenCheckingModal(false);
  };
  const closeFCheckingModal = () => {
    setOpenFCheckingModal(false);
  };
  return (
    <>
      <Snackbar
        open={successToast}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity="success" sx={{ width: "100%" }}>
          Boosted Successfuly!
        </Alert>
      </Snackbar>
      <Modal
        open={openCheckingModal}
        onClose={closeCheckingModal}
        disableAutoFocus={true}
      >
        <Box className="text-center successModal" sx={checkingModal}>
          <div className="text-center py-2 ">
            <h4>Checking for available credits, please wait..</h4>
          </div>
        </Box>
      </Modal>
      <Modal
        open={openFCheckingModal}
        onClose={closeFCheckingModal}
        disableAutoFocus={true}
      >
        <Box className="text-center successModal" sx={checkingModal}>
          <div className="text-center py-2 ">
            <h4>No credits available, redirecting to buy some.</h4>
          </div>
        </Box>
      </Modal>
      <div className="MyAdsArea_main ">
        {loading ? (
          <div className="No_ads_loading p-3 text-center">
            <div>
              <div className="row">
                <div className="col-lg-3">
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    width="100%"
                    height={170}
                  />
                </div>
                <div className="col-lg-9 d-flex flex-column justify-content-between">
                  <div className="d-flex align-items-top justify-content-between">
                    <div className="text-start">
                      <h4>
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          width={300}
                          height={20}
                        />
                      </h4>
                      <h6>
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          width={150}
                          height={20}
                        />
                      </h6>
                    </div>
                    <div>
                      <Skeleton
                        animation="wave"
                        variant="rounded"
                        width={8}
                        height={20}
                      />
                    </div>
                  </div>
                  <div className="d-flex align-items-center ">
                    <p>
                      <Skeleton
                        sx={{ marginRight: 2 }}
                        animation="wave"
                        variant="rounded"
                        width={30}
                        height={15}
                      />
                    </p>
                    <p>
                      <Skeleton
                        sx={{ marginRight: 2 }}
                        animation="wave"
                        variant="rounded"
                        width={30}
                        height={15}
                      />
                    </p>
                    <p>
                      <Skeleton
                        sx={{ marginRight: 2 }}
                        animation="wave"
                        variant="rounded"
                        width={30}
                        height={15}
                      />
                    </p>
                  </div>
                  <div>
                    <Skeleton
                      animation="wave"
                      variant="rounded"
                      width={60}
                      height={20}
                    />
                  </div>
                  <div className=" d-flex justify-content-end ">
                    <Skeleton
                      animation="wave"
                      variant="rounded"
                      width={100}
                      height={35}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : posts.length ? (
          posts.map((post) => (
            <div className="myAd p-3 mb-4" key={post.postId}>
              <div className="row">
                <div className="col-lg-3">
                  <div className="position-relative m-2 Myads_photos">
                    <img
                      src={`${awsImageURL}/posts/${post.post_token}/${post.cover}`}
                      alt={`${post?.makeName} ${post?.modelName} ${post?.yearName}`}
                      onError={(e) => {
                        e.target.src =
                          "https://gallery.famewheels.com/appgallery/no-image.png";
                      }}
                    />
                    {post?.post_type_id === 2 && (
                      <div className="d-flex align-items-center justify-content-between position-absolute top-0 w-100 ">
                        <div className="m-0 px-2 py-1 fw-600 featured-badge text-center">
                          FEATURED
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-9">
                  <div className="d-flex align-items-top justify-content-between">
                    <div className="vehicleDetails">
                      <h4>
                        {" "}
                        {`${post?.makeName} ${post?.modelName} ${post?.yearName}`}{" "}
                      </h4>
                      <h6>PKR: {formatPrice(post?.price || 0)}</h6>
                    </div>
                    <div key={post.post_id}>
                      <Button
                        sx={{ padding: 0, minWidth: "unset" }}
                        aria-describedby={post.post_id}
                        variant="text"
                        onClick={(event) => handleClick(event, post.post_id)}
                      >
                        <MoreVertIcon sx={{ color: "#000000" }} />
                      </Button>
                      <Popover
                        id={id}
                        open={popoverState[post.post_id] || false}
                        anchorEl={anchorEl}
                        onClose={() => handleClose(post.post_id)}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        elevation={0}
                        className="MyAds_options"
                        key={post.post_id}
                      >
                        <div>
                          <button
                            className="btn"
                            // key={post.postId}
                            onClick={() => soldPost(post.post_id)}
                          >
                            <DoneAllIcon
                              sx={{ fontSize: 20, marginRight: 1 }}
                            />
                            Sold Ad
                          </button>
                        </div>
                        <div>
                          <button
                            className="btn"
                            // key={post.postId}
                            onClick={() => editPost(post.post_id)}
                          >
                            <EditIcon sx={{ fontSize: 20, marginRight: 1 }} />
                            Edit Ad
                          </button>
                        </div>

                        <div>
                          <button
                            className="btn"
                            onClick={() => deletePost(post.post_id)}
                          >
                            <DeleteIcon sx={{ fontSize: 20, marginRight: 1 }} />
                            Delete Ad
                          </button>
                        </div>
                      </Popover>
                    </div>
                  </div>
                  <div className="d-flex align-items-center adViews_area">
                    <p>
                      <VisibilityIcon sx={{ marginRight: 1 }} />
                      Views: {post.counter}
                    </p>
                    <p>
                      <LocalPhoneIcon sx={{ marginLeft: 1, marginRight: 1 }} />
                      Tel: {post?.callscount}
                    </p>
                    <p>
                      <ChatIcon sx={{ marginLeft: 1, marginRight: 1 }} />
                      Chats: 0
                    </p>
                  </div>
                  <div className="d-flex justify-content-between align-items-end">
                    <div className="adstatus"></div>
                    <div className="text-end ad_controls">
                      <div>
                        <Button
                          key={post?.post_id}
                          onClick={() => handleInspectionAd(post?.post_id)}
                          className="text-capitalize"
                          variant="text"
                          color="inherit"
                        >
                          <ManageSearchIcon sx={{ fontSize: "large" }} />{" "}
                          <span className="ms-1"> Get Inspection</span>
                        </Button>
                        {post?.post_type_id !== 2 && (
                          <Button
                            key={post?.post_id}
                            onClick={() => handleFeatureAd(post?.post_id)}
                            className="text-capitalize"
                            variant="text"
                            color="inherit"
                          >
                            <Star sx={{ fontSize: "large" }} />{" "}
                            <span className="ms-1"> Feature Ad</span>
                          </Button>
                        )}

                        <Button
                          key={post?.post_id}
                          onClick={() => handleBoostAd(post?.post_id)}
                          className="text-capitalize"
                          variant="text"
                          color="inherit"
                        >
                          <PublishIcon sx={{ fontSize: "large" }} />{" "}
                          <span className="ms-1"> Boost Ad</span>
                        </Button>

                        <button
                          key={post.post_id}
                          onClick={() => openPost(post.post_id)}
                          className="btn fw-primary ms-3"
                        >
                          View Ad
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="No_ads p-3 text-center">
            <p>no active ads</p>
          </div>
        )}
      </div>

      <FeatureAd
        open={openSuccessModal}
        onClose={successClose}
        response={{ categoryName: parseInt(categoryName) }}
      />
    </>
  );
}
